<template>
  <normal-layout
      :title="'申请提现详情'"
      :content-background-color="'#F0F0F4'"
  >
    <template #left-btn>
      <left-button/>
    </template>
    <template #content>
      <div class="ad-container">
        <div class="ad-content">
          <img src="../../assets/images/wallet/ok.svg" alt>
          <p>提现申请提交成功</p>
          <span>提现申请将于1-2个工作内完成审核</span>
          <div class="adc-space">
            <div class="s-left"></div>
            <div class="s-center"></div>
            <div class="s-right"></div>
          </div>
          <div class="adc-bottom">
            <label>提现金额</label>
            <label class="b-money">{{ `${money}元` }}</label>
          </div>
        </div>
        <p class="ad-button" @click="know">我知道了</p>
      </div>
      <bank-identity/>
    </template>
  </normal-layout>
</template>

<script>
import NormalLayout from '../../components/actionbar/BasicLayout'
import LeftButton from '../../components/actionbar/TopLeftButton'
import BankIdentity from './components/BankIdentity'

export default {
  name: 'ApplyMoneyDetails',
  components: {
    NormalLayout,
    LeftButton,
    BankIdentity
  },
  data() {
    return {
      money: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { money = 0 } = this.$route.query || {}
      this.money = money
    })
  },
  methods: {
    know() {
      this.$JD.goBack()
    }
  }
}
</script>

<style scoped lang="scss">
.ad-container {
  display: flex;
  flex-direction: column;

  .ad-content {
    background: #FFFFFF;
    border-radius: .1rem;
    margin: .087rem .1rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 1.053rem;
      height: 1.053rem;
      margin-top: .62rem;
    }

    p {
      font-size: .24rem;
      color: #333333;
      margin-top: .267rem;
    }

    span {
      font-size: .173rem;
      color: #8B8B8B;
      margin-top: .167rem;
      margin-bottom: .3rem;
    }

    .adc-space {
      width: 100%;
      height: .428rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;

      .s-left {
        width: .214rem;
        height: .428rem;
        background-color: #F0F0F4;
        border-top-right-radius: .428rem;
        border-bottom-right-radius: .428rem;
      }

      .s-center {
        height: .5px;
        flex: 1;
        border: .5px #E4E4E4 dashed;
      }

      .s-right {
        width: .214rem;
        height: .428rem;
        background-color: #F0F0F4;
        border-top-left-radius: .428rem;
        border-bottom-left-radius: .428rem;
      }
    }

    .adc-bottom {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: .34rem .213rem .48rem;

      label {
        color: #333333;
        font-size: .2rem;
      }

      .b-money {
        color: #6D6D6D;
      }
    }
  }

  .ad-button {
    height: .56rem;
    margin-left: .167rem;
    margin-right: .167rem;
    margin-top: .533rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .213rem;
    color: white;
    background-color: #EC2B24;
    border-radius: .053rem;
  }
}
</style>
